import { client } from "utils/axios";
import * as yup from "yup";

export const createInputs = async (inputs, formName) => {
  try {
    if (formName === "Telas") {
      const payload = {
        date: inputs.date,
        description: inputs.description,
        code: inputs.code,
        amount: inputs.amount,
        kg: inputs.kg,
        meters: inputs.meters,
        unit: inputs.unit?.name || inputs.unit || null,
        category: inputs.category ? { id: inputs.category.id } : undefined,
        supplier: inputs.supplier ? { id: inputs.supplier.id } : undefined,
        rolls: (inputs.rolls || [])
          .filter((r) => r.code && r.cloth)
          .map((r) => ({
            cloth: { id: r.cloth.id },
            color: r.color,
            totalKg: r.totalKg,
            meters: r.meters,
            code: r.code,
            userUpdate: "admin",
            is_void: false,
          })),
      };
      await client.post("inputs/with-rolls", payload);
    } else if (formName === "Maquinaria") {
      const { data } = await client.post("inputs", inputs);
      if (data.id) {
        await Promise.all(
          inputs.machinary.map(async (item) => {
            await client.post("machinary", {
              ...item,
              inputs: { id: data.id },
              category: { id: item.category.id },
            });
          })
        );
      }
    } else {
      await client.post("inputs", inputs);
    }
    return true;
  } catch (error) {
    console.log("Error en createInputs:", error?.response?.data ?? error);
    return false;
  }
};
export async function getAllInputs() {
  const { data } = await client.get("/inputs");
  return data;
}
export async function getFilterByRolls(id) {
  const { data } = await client.get(`/rolls/filterInput/${id}`);
  return data;
}
export async function getAllRolls() {
  const { data } = await client.get("/rolls");
  return data;
}
export async function getAllCategorias() {
  const { data } = await client.get("/categorias");
  return data;
}
export async function getAllCategories() {
  const { data } = await client.get("/category");
  return data;
}
export async function getAllTelas() {
  const { data } = await client.get("/cloth");
  return data;
}

export async function getAllSupplier() {
  const { data } = await client.get("/supplier");
  return data;
}
export const validationSchemaInputs = yup.object({
  nombre: yup
    .string("Ingresa nombre de la Entrada")
    .required("Campo Requerido"),
  dimensiones: yup
    .string("Ingresa las dimensiones de la Entrada")
    .required("Campo Requerido"),
  descripcion: yup.string("Ingresa Descripción").required("Campo Requerido"),
  codigo: yup.string("Ingresa Código").required("Campo Requerido"),
});
export const deleteInputs = (inputsId) => async (dispatch) => {
  await client.delete(`inputs/${inputsId}/with-rolls`);
};

export const modifyInputs = async (inputs, isMenuFormName) => {
  try {
    if (isMenuFormName === "Telas") {
      const payload = {
        date: inputs.date,
        description: inputs.description,
        code: inputs.code,
        amount: inputs.amount,
        kg: inputs.kg,
        meters: inputs.meters,
        unit: inputs.unit?.name || inputs.unit || null,
        category: inputs.category ? { id: inputs.category.id } : undefined,
        supplier: inputs.supplier ? { id: inputs.supplier.id } : undefined,
        rolls: (inputs.rolls || [])
          .filter((r) => r.code && r.cloth)
          .map((r) => ({
            ...(r.id ? { id: r.id } : {}),
            cloth: { id: r.cloth?.id },
            color: r.color,
            totalKg: r.totalKg,
            meters: r.meters,
            code: r.code,
            userUpdate: "admin",
            is_void: false,
          })),
      };
      await client.put(`inputs/${inputs.id}/with-rolls`, payload);
    } else {
      const payload = {
        date: inputs.date,
        description: inputs.description,
        amount: inputs.amount,
        kg: inputs.kg,
        meters: inputs.meters,
        category: inputs.category ? { id: inputs.category.id } : undefined,
        supplier: inputs.supplier ? { id: inputs.supplier.id } : null,
        unit: inputs.unit?.name || inputs.unit || null,
      };
      await client.put(`inputs/${inputs.id}`, payload);
    }
    return true;
  } catch (error) {
    console.log("Error en modifyInputs:", error?.response?.data ?? error);
    return false;
  }
};
